export enum DashboardTourEnum {
  GENERAL_TOUR = "general-tour",
  AUTOCALLER_TOUR = "autocaller-tour",
  LEAD_RESPONDER_TOUR = "lead-responder-tour",
  IVT_TOUR = "ivt-tour",
}
